<template>
  <div class="app-frame">
    <div class="app-frame__grid transition-all duration-300" :class="isMobile ? 'grid-cols-1' : 'grid-cols-[auto,1fr]'">
      <!-- Sidebar desktop -->
      <div v-if="!isMobile" class="app-frame__sidebar" :style="{ width: sidebarWidth }">
        <AppSidebar :minimized="isSidebarMinimized" @update:minimized="isSidebarMinimized = $event" />
      </div>

      <!-- Sidebar overlay mobile (solo si quieres mostrarlo) -->
      <Transition name="slide">
        <div v-if="isMobile && sidebarVisible" class="fixed inset-0 z-50">
          <AppSidebar :visible="sidebarVisible" @update:visible="sidebarVisible = $event" />
        </div>
      </Transition>

      <!-- Contenido principal -->
      <div class="app-frame__column">
        <AppNavbar :is-mobile="isMobile" @toggleSidebar="sidebarVisible = !sidebarVisible" />
        <main class="app-frame__scroll" :class="{ 'app-frame__scroll--mobile': isMobile }">
          <article class="w-[95%] max-w-[1320px] mx-auto mt-4">
            <RouterView />
          </article>
        </main>
      </div>

      <!-- Bottom tabs para móvil -->
      <TopTabsNavigation v-if="isMobile" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import AppNavbar from '../components/navbar/AppNavbar.vue'
import AppSidebar from '../components/sidebar/AppSidebar.vue'
import TopTabsNavigation from '../components/top-tabs-navegation/TopTabsNavigation.vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../stores/global-store'

const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)

const width = ref(window.innerWidth)
const isMobile = ref(false)
const sidebarVisible = ref(false)

const expandedWidth = 280
const collapsedWidth = 70
const sidebarWidth = computed(() => (isSidebarMinimized.value ? `${collapsedWidth}px` : `${expandedWidth}px`))

function checkWidth() {
  width.value = window.innerWidth
  isMobile.value = width.value <= 820
  if (isMobile.value) {
    sidebarVisible.value = false
    isSidebarMinimized.value = false
  }
}

onMounted(() => {
  checkWidth()
  window.addEventListener('resize', checkWidth)
})

onUnmounted(() => window.removeEventListener('resize', checkWidth))
</script>

<style scoped>
.app-frame {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-frame__grid {
  flex: 1;
  min-height: 0;
  display: grid;
  overflow: hidden;
}

.app-frame__sidebar,
.app-frame__column {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.app-frame__column {
  display: flex;
  flex-direction: column;
}

.app-frame__scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.app-frame__scroll--mobile {
  padding-bottom: calc(64px + 5rem + env(safe-area-inset-bottom));
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
